import React, { SVGProps } from 'react';

export const IconCheckmark = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="m6.65 14.35-2.3 2.3a.5.5 0 0 0 0 .7l8.3 8.3c.2.2.5.2.7 0l14.3-14.3a.5.5 0 0 0 0-.7l-2.3-2.3a.5.5 0 0 0-.7 0l-11.3 11.3a.5.5 0 0 1-.7 0l-5.3-5.3a.5.5 0 0 0-.7 0Z"/></svg>;
